import axios from "axios";
import axiosInstance from "../services/AxiosInstance";
import CryptoJS from "crypto-js";
import swal from "sweetalert";


const ENCRYPTION_KEY = "9z$C&F)J@NcRfTjW";
const ENCRYPTION_IV = "ABCDEFGH";

export const decrypt = (cipherText) => {
  try {
    if (!cipherText) return "";

    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
    const iv = CryptoJS.enc.Utf8.parse(ENCRYPTION_IV);

 
    let firstPass = CryptoJS.TripleDES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(cipherText) },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);

   
    firstPass = firstPass.replace(/^"|"$/g, "");

   
    if (/^[A-Za-z0-9+/=]+$/.test(firstPass)) {
      try {
        const secondPass = CryptoJS.TripleDES.decrypt(
          { ciphertext: CryptoJS.enc.Base64.parse(firstPass) },
          key,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        ).toString(CryptoJS.enc.Utf8);

        if (secondPass) return secondPass;
      } catch (e) {
        console.warn("Second pass decryption failed, returning first pass.");
      }
    }

    return firstPass;
  } catch (error) {
    console.error("Decryption Error:", error);
    return "";
  }
};



export const getData = async (URL, params = {}, ) => {
    try {
        const response = await axiosInstance.get(URL, { params });

        if (response?.data?.error == 200) {
            sessionStorage.setItem('accessToken', JSON.stringify(response.data.access_token));
            sessionStorage.setItem('refreshToken', JSON.stringify(response.data.refresh_token));
        }

        const Data = response?.data?.data;
        let parceData;

        if (typeof Data === 'string' && /^[A-Za-z0-9+/=]+$/.test(Data)) {
            const decryptedData = decrypt(Data);
            parceData = JSON.parse(decryptedData);
        } else {
            parceData = JSON.parse(Data);
        }

        return parceData?.Table;

    } catch (error) {
        console.error('Error fetching data:', error);

      
        if (error.response && error.response.status === 401) {
            console.error('Token expired. Attempting to refresh token.');

            try {
                const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken'));

                const res = await getPostData(
                    'Authorize/GetToken',
                    { grant_type: 'refresh_token', refresh_token: refreshToken },
           
                );

                
                return await getData(URL, params);

            } catch (refreshError) {
                console.error('Failed to refresh token or re-authenticate:', refreshError);
            }
        } else {
            console.error('API call failed:', error);
        }
    } finally {
     
    }
};

         

export const getPostData = async (URL, postData, dispatch, isRetry = false) => {
    try {
        const response = await axiosInstance.post(URL, postData);

        if (response?.data?.error == 200) {
            sessionStorage.setItem('accessToken', JSON.stringify(response.data.access_token));
            sessionStorage.setItem('refreshToken', JSON.stringify(response.data.refresh_token));
        }

        const Data = response?.data?.data;
        let parceData;

        if (typeof Data === 'string' && /^[A-Za-z0-9+/=]+$/.test(Data)) {
            const decryptedData = decrypt(Data);
            parceData = JSON.parse(decryptedData);
        } else {
            parceData = JSON.parse(Data);
        }

        return parceData?.Table;
    } catch (error) {
        console.error('Error fetching data:', error);

       
        if (error.response && error.response.status === 401) {
            console.error('Token expired. Attempting to refresh token.');

           
            if (isRetry) {
                console.error('Already retried. Not retrying again.');
                return;
            }

            try {
                const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken'));

              
                const res = await getPostData(
                    'Authorize/GetToken',
                    {
                        grant_type: 'refresh_token',
                        refresh_token: refreshToken,
                    },
                    dispatch,
                    true 
                );

              
                return await getPostData(URL, postData, dispatch, true);
            } catch (refreshError) {
                console.error('Failed to refresh token or re-authenticate:', refreshError);
            }
        } else {
            console.error('API call failed:', error);
        }
    }
};


export const requestGet = async (URL, params = {}) => {
    try {
        const response = await axiosInstance.get(URL, { params });
        return response; 
    } catch (error) {
        console.error('requestGet error:', error);
        if (error.response && error.response.status === 401) {
            console.error('Token expired for requestGet. Attempting to refresh token.');
            try {
                const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken'));
                const tokenRes = await AddUpdate('Authorize/GetToken', { grant_type: 'refresh_token', refresh_token: refreshToken });
                const newAccess = tokenRes?.data?.access_token || JSON.parse(sessionStorage.getItem('accessToken'));
                if (newAccess) axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;
                return await requestGet(URL, params);
            } catch (refreshError) {
                console.error('Failed to refresh token for requestGet:', refreshError);
                throw error;
            }
        }
        throw error;
    }
};

export const requestPost = async (URL, postData = {}) => {
    try {
        const response = await axiosInstance.post(URL, postData);
        return response; 
    } catch (error) {
        console.error('requestPost error:', error);
        if (error.response && error.response.status === 401) {
            console.error('Token expired for requestPost. Attempting to refresh token.');
            try {
                const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken'));
                const tokenRes = await AddUpdate('Authorize/GetToken', { grant_type: 'refresh_token', refresh_token: refreshToken });
                const newAccess = tokenRes?.data?.access_token || JSON.parse(sessionStorage.getItem('accessToken'));
                if (newAccess) axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;
                return await requestPost(URL, postData);
            } catch (refreshError) {
                console.error('Failed to refresh token for requestPost:', refreshError);
                throw error;
            }
        }
        throw error;
    }
};



export const AddUpdate = async (url, postData) => {
    try {
        const res = await axiosInstance.post(url, postData);
          if (res?.data?.error == 200) {
            sessionStorage.setItem('accessToken', JSON.stringify(res.data.access_token));
            sessionStorage.setItem('refreshToken', JSON.stringify(res.data.refresh_token));
        }
        return res;

    } catch (error) {
        console.error('Error fetching data:', error);

                                     

        if (error.response && error.response.status === 401) {
            console.error('Token expired. Attempting to refresh token.');
       

            try {

                const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken'));
              

                const res = await AddUpdate('Authorize/GetToken', { "grant_type": "refresh_token", "refresh_token": refreshToken });
                 

                // return res;
                    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${res?.data?.access_token}`;
                  return await AddUpdate(url, postData);


            } catch (refreshError) {
                console.error('Failed to refresh token or re-authenticate:', refreshError);

            }
        } else {

            console.error('API call failed:', error);
        }

    } finally {

    }
}





export const getPostTicketData = async (url, postData) => {
    try {
        const res = await axiosInstance.post(url, postData);
        const { data } = res
        return data;



    } catch (error) {
        console.error(error)
    }
}


